<template>
    <div class="pop-up">
        <div
            class="old-site-container"
            :class="{ 'slide-down': slideDownOldSiteContainer }"
        >
            <div class="position-wrapper">
                <div class="info-text">
                    {{ $t('sign-in.old-site-info') }}
                </div>
                <button class="bnr-button" @click.prevent="goToOldSite">
                    {{ $t('sign-in.old-site-button') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue';

export default {
    setup() {
        const slideDownOldSiteContainer = ref(true);

        onMounted(() => {
            setTimeout(() => {
                slideDownOldSiteContainer.value = false;
            }, 500);
        });

        function goToOldSite() {
            window.location.href = 'https://old.taxifix.no';
        }

        return {
            slideDownOldSiteContainer,

            goToOldSite
        };
    }
};
</script>
